export default "__VITE_ASSET__Dc8UheXB__"